<template>
  <div class="news">
    <div class="news-list" v-for="(item, i) in newsList" :key="i">
      <div class="list-left">
        <img :src="item.url" alt="" />
      </div>
      <div class="list-right">
        <div class="top">
          <span class="title_name">{{ item.title }}</span>
          <span class="title_time">{{ item.createData }}</span>
        </div>
        <div class="matter" v-html="item.content"></div>
        <div class="more_link" @click="moreEvent(item.id)">查看详情 >></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // props:{
  //   type:{
  //     type:Number,
  //     default:1
  //   }
  // },
  data() {
    return {
      newsList: [],
      flag: true,
    };
  },
  mounted() {
    this.getNews();
  },
  methods: {
    moreEvent(id) {
      console.log(id);
      this.$emit("myEvent", this.flag, id, this.newsList);
    },
    getNews() {
      this.$axios.get("/content/content/listAll/2").then((res) => {
        console.log(res);
        this.newsList = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.news {
  width: 100%;
  .news-list {
    margin: 0 0 40px;
    padding: 20px;
    background: #ffffff;
    box-shadow: -1px 7px 13px 0px rgba(24, 24, 24, 0.11);
    display: flex;
    justify-content: space-between;
    height: 300px;
    .list-left {
      width: 30%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .list-right {
      width: 65%;
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title_name {
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 700;
          color: #2f2f2f;
          line-height: 48px;
          max-height: 50px;
          // width: 120px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .title_time {
          text-align: right;
        }
      }
      .matter {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #808080;
        line-height: 36px;
        text-indent: 2em;
        text-align: left;
        margin: 20px 0;
        height: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
      }
      .more_link {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #3660d9;
        line-height: 48px;
        text-align: right;
      }
    }
  }
}
@media screen  and (max-width: 1366px){
  .title_name{
    width: 100px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newsCenter/announcement.vue